export const winteryreds = {
  name: 'Wintery Reds',
  color: [0.8431372549019608, 0.17254901960784313, 0.08627450980392157, 1],
  bg: [0.9254901960784314, 0.5882352941176471, 0.6431372549019608, 1],
  grid1: [0.9411764705882353, 0.9372549019607843, 0.9176470588235294, 1],
  grid2: [0.7529411764705882, 0.6980392156862745, 0.7098039215686275, 1],
}
